'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    ", "\n    &::before {\n        content: '';\n        display: block;\n        height: 0;\n        padding-bottom: ", "%;\n    }\n"], ["\n    position: relative;\n    ", "\n    &::before {\n        content: '';\n        display: block;\n        height: 0;\n        padding-bottom: ", "%;\n    }\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return (maxWidth ? "max-width: ".concat(maxWidth, "px;") : '');
}, function (_a) {
    var ratioInPercent = _a.ratioInPercent;
    return ratioInPercent;
});
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n"], ["\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n"])));
var templateObject_1, templateObject_2;

export { Container, Content };
//# sourceMappingURL=styles.js.map
